import Webview from '../native/visible/Webview'
import PlayerView from '../native/visible/PlayerView'
import SingleOfferTemplate from "./SingleOfferTemplate";


class VideoTemplate extends SingleOfferTemplate{
    constructor(props = {}) {
        super(props)
    }

    initComponents() {
        if(!this.container){
            this.container = new Webview()
        }
        console.log('init player; ', this.campaign, this.unit, this)
        this.playerView = new PlayerView({
            campaign: this.campaign,
            unitId: this.unit.id,
            mute: false,
            showTime: true,
            showMute: true,
            showClose: true,
        })
    }

    initSlots(){
        super.initSlots()
        //this.slotIn('slot_video', this.playerView)
        //this.slotInBelow('slot_video', this.playerView)
    }


    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.playerView && this.playerView.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return Promise.all([super._isLoadFinish(), this.playerView.whenCreateSuccess()])
    }

}

export default VideoTemplate